<div class="training-invite" *ngIf="training">
  <div class="training-invite-card">
    <div class="training-location-image">
      <img [src]="training.logoUrl | safe:'url'" />
    </div>
    <div class="training-invite-card-title">
      {{ "MY-INVITATION.OVERVIEW.TITLE" | translate }}
    </div>
    <div class="training-invite-card-subtitle">
      {{ "MY-INVITATION.OVERVIEW.SUBTITLE" | translate }}
      {{ training.admin.firstName + ' ' +  training.admin.lastName}}
    </div>
    <app-panel>
      <div class="training-image-container">
        <img
          class="training-image"
          [src]="(training.imageFile?.fileUrl ?? null) | safe:'url'"
          appTrainingImageFallback
        />
      </div>
      <div class="training-name">{{ training.name }}</div>
      <div class="training-description">{{ training.description }}</div>
      <div class="training-info">
        <div class="trainer-container">
          <div 
            *ngFor="let trainer of trainers" 
            class="trainer-card-wrapper"
          >
            <app-trainer-card
              [trainer]="trainer"
              [maxNameLength]="20"
              fontSize="16px"
              avatarSize="35px"
              fontColor="black"
            ></app-trainer-card>
          </div>
        </div>
        <div class="training-stats">
          <div *ngIf="training.iddTime" class="training-stats-item">
            {{ "COMMON.FIELDS.IDD-TIME-CREDIT" | translate }}:
            {{ durationString }}
          </div>
        </div>
      </div>
      <div class="training-widgets">
        <div class="training-widget-item">
          <div class="training-widget-badge">
            <i class="dx-icon dx-svg-icon" [innerHTML]="getCalendarIcon()"></i>
            {{ "COMMON.DATE" | translate }}:
          </div>
          <div class="training-widget-value">
            <div
              *ngFor="let date of training.dates"
              class="training-dates-block"
            >
              <div class="training-dates-block-date">
                {{
                  training.dates[0]
                    | trainingDate : translateService.currentLang
                }}
              </div>
              <div *ngIf="translateService.currentLang == 'en'">
                {{ training.dates[0].start | date : "hh:mm a" }} -
                {{ training.dates[0].end | date : "hh:mm a" }}
              </div>
              <div *ngIf="translateService.currentLang == 'de'">
                {{ training.dates[0].start | date : "HH:mm" }} -
                {{ training.dates[0].end | date : "HH:mm" }}
              </div>
            </div>
          </div>
        </div>
        <div class="training-widget-item">
          <div class="training-widget-badge">
            <i class="dx-icon-map dx-svg-icon"></i>
            {{ "COMMON.FIELDS.LOCATION" | translate }}:
          </div>
          <div class="training-widget-value">
            <span
              *ngIf="training.locationType == TrainingLocationType.GoToWebinar"
            >
              GoTo Webinar
            </span>
            <span *ngIf="training.locationType == TrainingLocationType.Webex">
              Webex
            </span>
            <span *ngIf="training.locationType == TrainingLocationType.MsTeamsWebinar">
              Teams Webinar
            </span>
            <span *ngIf="training.locationType == TrainingLocationType.MsTeamsMeetings">
              Teams Meeting
            </span>
            <span *ngIf="training.locationType == TrainingLocationType.Zoom">
              Zoom Webinar
            </span>
            <span *ngIf="training.locationType == TrainingLocationType.Web">
              {{ "MY-INVITATION.ONLINE-MEETING" | translate }}
            </span>
            <span
              *ngIf="
                training.locationType == TrainingLocationType.ExternalEvent
              "
            >
              {{ 'COMMON.FIELDS.EVENT-TYPES.EXTERNAL-EVENT' | translate }}
            </span>
            <span
              *ngIf="
                training.locationType != TrainingLocationType.GoToWebinar &&
                training.locationType != TrainingLocationType.Webex &&
                training.locationType != TrainingLocationType.MsTeamsWebinar &&
                training.locationType != TrainingLocationType.MsTeamsMeetings &&
                training.locationType != TrainingLocationType.Zoom &&
                training.locationType != TrainingLocationType.Web &&
                training.locationType != TrainingLocationType.ExternalEvent
              "
            >
              {{ training.location }}
            </span>
            <div
              class="training-location-details"
              *ngIf="locationDisplay as location"
            >
              <div class="training-location-details-title">
                {{ "COMMON.FIELDS.LOCATION-DETAILS" | translate }}
              </div>

              <ng-container *ngIf="location.url; else locationTextTemplate">
                <a 
                  [href]="location.url" 
                  target="_blank" 
                  rel="noopener noreferrer"
                >
                  {{ location.text }}
                </a>
              </ng-container>

              <ng-template #locationTextTemplate>
                <span>{{ location.text }}</span>
              </ng-template>
            </div>
          </div>
        </div>
      </div>
      <div class="training-cta-section">
        <div
         *ngIf="training.status === 0 && !isInvitationAccepted" 
          class="action-buttons-container open-section"
        >
          <dx-button *ngIf="!isExternalEvent"
            class="action-button btn-accept-invitation"
            [text]="'MY-TRAININGS.OVERVIEW.ACCEPT-INVITATION' | translate"
            type="normal"
            (click)="onAcceptInvitationClick()"
          ></dx-button>
          <dx-button *ngIf="isExternalEvent"
            class="action-button"
            [text]="'MY-TRAININGS.OVERVIEW.GO-TO-EVENT' | translate"
            type="normal"
            (click)="goToExternalEvent()"
          ></dx-button>
          <dx-button
            *ngIf="accessToken && !isInvitationDeclined"
            class="action-button btn-decline-invitation"
            [text]="'MY-TRAININGS.OVERVIEW.DECLINE-INVITATION' | translate"
            type="danger"
            (click)="onDeclineInvitationClick()"
          ></dx-button>
        </div>
        <div 
          *ngIf="isInvitationAccepted"
          class="action-buttons-container accepted-section"
        >
          <dx-button
            class="action-button btn-decline"
            [text]="'MY-TRAININGS.OVERVIEW.DECLINE-INVITATION' | translate"
            type="danger"
            (click)="onDeclineTrainingClick()"
          >
          </dx-button>
          <dx-button
            class="action-button btn-download"
            [text]="'MY-INVITATION.DOWNLOAD-ICS' | translate"
            type="normal"
            (click)="onDownloadIcs()"
          >
          </dx-button>
        </div>
        <div class="action-buttons-container booked-section" *ngIf="training.status === 2 && !isInvitationAccepted">
          @if(accessToken && training.memberStatus == MemberStatus.Waiting) {
            <dx-button
              [text]="'MY-TRAININGS.TRAINING-QUEUE.REMOVE-ME-FROM-QUEUE' | translate"
              type="danger"
              (click)="onRemoveFromQueueClick()"
            ></dx-button>
          } @else {
            <div class="training-info-text">
              {{ "MY-INVITATION.EVENT-BOOKED" | translate }}
            </div>
            <dx-button
              [text]="'MY-TRAININGS.TRAINING-QUEUE.ADD-ME-TO-QUEUE' | translate"
              type="normal"
              (click)="onAddToQueueClick()"
            ></dx-button>
          }
        </div>
        <div class="training-info-text" *ngIf="training.status === 1">
          {{ "MY-INVITATION.OLD-EVENT" | translate }}
        </div>
        <div class="training-info-text" *ngIf="training.status === 3">
          {{ "MY-INVITATION.EVENT-CANCELLED" | translate }}
        </div>
      </div>
      <div class="training-section">
        <div class="training-section-title">
          {{ "COMMON.FIELDS.DESCRIPTION" | translate }}
        </div>
        <dx-html-editor
          label=""
          [(value)]="training.descriptionExtended"
          [readOnly]="true"
        >
        </dx-html-editor>
      </div>
      <div class="training-section training-section-location">
        <div *ngIf="training.locationType == TrainingLocationType.Address">
          <ng-container *ngIf="training.latitude && training.longitude">
            <app-google-maps
              class="training-map my-3"
              [location]="location"
            ></app-google-maps>
          </ng-container>
        </div>
        <div
          *ngIf="training.locationType == TrainingLocationType.GoToWebinar"
          class="training-location-image-container"
        >
          <img
            class="training-location-image"
            src="assets/img/gotowebinar-logo.jpg"
          />
        </div>
        <div
          *ngIf="training.locationType == TrainingLocationType.Webex"
          class="training-location-image-container"
        >
          <img
            class="training-location-image"
            src="assets/img/webex-logo.jpg"
          />
        </div>
      </div>
    </app-panel>
  </div>
</div>

<app-accept-invitation-modal
  *ngIf="showAcceptInvitationModal && training"
  [(showModal)]="showAcceptInvitationModal"
  [training]="training"
  [trainingKey]="trainingKey"
  [(accessKey)]="accessToken"
  [channelToken]="channelToken"
  [questions]="training.questions"
  [registrationFieldConfigs]="registrationFieldConfigs"
  [remainingParticipantSlots]="training.remainingParticipantSlots"
  (onInviteAccepted)="onInviteAccepted()"
  (onAddedToQueue)="onAddedToQueue()"
></app-accept-invitation-modal>

<app-token-accept-flow
  *ngIf="showTokenAcceptFlow && training"
  [(showModal)]="showTokenAcceptFlow"
  [training]="training"
  [trainingKey]="trainingKey"
  [(accessKey)]="accessToken"
  [channelToken]="channelToken"
  [questions]="training.questions"
  [remainingParticipantSlots]="training.remainingParticipantSlots"
  (onInviteAccepted)="onInviteAccepted()"
  (onAddedToQueue)="onAddedToQueue()"
></app-token-accept-flow>

<app-decline-invitation-modal
  *ngIf="showDeclineInvitationModal"
  [(showModal)]="showDeclineInvitationModal"
  [trainingKey]="trainingKey"
  [accessToken]="accessToken"
  (onInviteDeclined)="onInviteDeclined()"
></app-decline-invitation-modal>